module.exports = "<div class=\"categoryList-aisle olyStickyHeader fix-touch-scrolling\" ng-click=\"redirectBack()\">\r\n\r\n    <h3 class=\"categoryList-aisleName\">\r\n        <span class=\"categoryList-aisleNameInner\">{{title}}</span>\r\n    </h3>\r\n    <img loading=\"lazy\" class=\"categoryList-aisleImage\" ng-src=\"{{imageToUse()}}\" alt=\"\" oly-error-src/>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/sticky-header/sticky-header-with-image-template.html
 ** module id = 856
 ** module chunks = 2
 **/